import React, { useState, useRef, useEffect } from "react";
import Utils from "Utils/utils";
import SearchInputBox from "Components/common/SearchInputBox";

const CustomDropdown = props => {
  const {
    options = [],
    customCbk = () => {},
    refValue = null,
    handleScrollEnd = () => {},
    hasValue = false,
    emptyText = "",
    hasCustomFieldValue: hasCustomText = false,
    loader = false,
    parentIndex = "",
    childIndex = "",
    hasFolderBadge = false,
    disableOptions = [],
    isFromPageName = "",
    search = false,
    searchPlaceholder = "Search",
    filterFn = () => {}
  } = props;

  const internalSearchRef = useRef(null);
  const searchBoxRef = props.searchBoxRef || internalSearchRef;
  const dropdownRef = useRef(null);

  const [searchValue, setSearchValue] = useState("");

  const defaultFilterFn = (opt, searchVal) =>
    (opt?.name || "").toLowerCase().includes(searchVal.toLowerCase());

  const filterFunc = filterFn || defaultFilterFn;

  const filteredOptions =
    searchValue && search
      ? options.filter(opt => filterFunc(opt, searchValue))
      : options;

  useEffect(() => {
    if (
      dropdownRef.current &&
      props.animationClass === "customDropDownFadeIn"
    ) {
      const listHeight =
        dropdownRef.current.querySelector(".dropdownList")?.offsetHeight || 0;
      dropdownRef.current.style.setProperty("--list-height", `${listHeight}px`);
    }
  }, [filteredOptions, props.animationClass]);

  const dropdownCbkmethod = (e, item) => {
    if (e) Utils.preventDefaultFn(e);
    customCbk(item, parentIndex, childIndex);
  };

  const getAnimationClass = () => {
    return props?.animationClass ? props?.animationClass : "";
  };

  return loader ? (
    <CustomDropdownLoader />
  ) : (
    <div
      ref={dropdownRef}
      className={`drop-down-menu animatedFast ${getAnimationClass()}`}
    >
      <div className="searchButtonWrapper">
        {search && (
          <SearchInputBox
            type="text"
            placeholder={searchPlaceholder}
            searchBoxRef={searchBoxRef}
            valueCbk={val => {
              setSearchValue(val);
            }}
          />
        )}
      </div>
      <ul className="dropdownList" onScroll={handleScrollEnd} ref={refValue}>
        {filteredOptions?.length ? (
          filteredOptions?.map((item, index) => {
            const {
              name = "",
              email = "",
              key = "",
              shareType = "",
              accessType = "",
              owner = {},
              memberId = "",
              value = "",
              hasCustomFieldValue = "",
              Icon = <></>,
              hasIcon = false,
              disabled = false,
              folderName = ""
            } = item || {};
            const disableOption = disableOptions?.includes(item?.id);
            return (
              <li
                key={`menu_${index}`}
                id={key}
                onClick={
                  disabled || disableOption
                    ? () => {}
                    : e => dropdownCbkmethod(e, item)
                }
                className={`option ${
                  disabled || disableOption ? "disabled" : ""
                }`}
                title={name}
              >
                <div className="listItem">
                  <div className="listItemWrap">
                    {hasIcon && Icon && (
                      <span className="itemIcon">
                        <Icon />
                      </span>
                    )}
                    <span className="itemName">
                      {hasValue
                        ? value
                        : isFromPageName === "tasks"
                        ? Utils.getEntityNameUpdated(
                            shareType,
                            accessType,
                            owner,
                            name || email,
                            memberId,
                            hasFolderBadge ? folderName : ""
                          )
                        : Utils.getEntityName(
                            shareType,
                            accessType,
                            owner,
                            name || email,
                            memberId
                          )}
                    </span>
                    {hasCustomText && hasCustomFieldValue && (
                      <span className="customText">Custom</span>
                    )}
                  </div>
                </div>
              </li>
            );
          })
        ) : (
          <span className="noSequencesMsg">{emptyText}</span>
        )}
      </ul>
    </div>
  );
};

const CustomDropdownLoader = () => {
  return (
    <div className={`drop-down-menu`}>
      <ul className="dropdownList">
        {Array.from({ length: 10 }, (value, index) => (
          <li className="option optionLoader" key={`${index}`}>
            <div className="listItem linear-background" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export { CustomDropdown };
export default CustomDropdown;
